import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class AnalyticsService {
  constructor() {
  }
  sendEvent(eventName: string, eventParams: any = {}): void {
    if ((window as any).gtag) {
     ( window as any).gtag('event', eventName, eventParams);
    } 
    else {
      console.log('Google Analytics לא נטען כראוי.');
    }
  }
}
